import { ModuleWithResourcesAndTasksRequestApi } from "../DTO/ClientRequest/ModuleRequest";
import {
  isModuleResponseDTO,
  isModuleWithResourcesResponseDTO as isModuleWithResourcesAndTasksResponseDTO,
  ModuleResponseApi,
  ModuleWithResourcesAndTasksResponseApi,
} from "../DTO/ServerResponseType/Module/Module";
import {
  isModuleIdsResponseDTO,
  ModuleIdsApi,
} from "../DTO/ServerResponseType/Module/ModuleId";
import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class ModuleServerClient {
  private path = "/module";

  sendToGetModuleWithResourcesAndTasksByModuleIdAsync = async (
    moduleId: string
  ): Promise<ModuleWithResourcesAndTasksResponseApi | never> => {
    let url: string =
      serverOrigin +
      this.path +
      "/show/one?moduleId=" +
      moduleId +
      "&withResourcesAndTasks=true";

    let module: ModuleWithResourcesAndTasksResponseApi =
      await getTypeGuardedVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isModuleWithResourcesAndTasksResponseDTO
      );

    return module;
  };

  sendToUpdateModuleAsync = async (
    moduleId: string,
    moduleNewData: ModuleWithResourcesAndTasksRequestApi
  ): Promise<ModuleIdsApi | null> => {
    return getTypeGuardedVariableAsync(
      this.sendUpdatedModuleAsync(moduleId, moduleNewData),
      isModuleIdsResponseDTO
    )
      .then((moduleIdsDTO: ModuleIdsApi) => {
        alert("Модуль успешно изменен.");
        return moduleIdsDTO;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        return null;
      });
  };

  sendUpdatedModuleAsync = async (
    moduleId: string,
    moduleNewData: ModuleWithResourcesAndTasksRequestApi
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/update/all";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        moduleId: moduleId,
        moduleNewData: moduleNewData,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToCreateModuleAsync = async (
    moduleData: ModuleWithResourcesAndTasksRequestApi
  ): Promise<ModuleIdsApi | null> => {
    return getTypeGuardedVariableAsync(
      this.sendNewModuleAsync(moduleData),
      isModuleIdsResponseDTO
    )
      .then((moduleIdsDTO: ModuleIdsApi) => {
        alert("Модуль успешно создана.");
        return moduleIdsDTO;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        return null;
      });
  };

  sendNewModuleAsync = async (
    module: ModuleWithResourcesAndTasksRequestApi
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(module),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToGetAllModulesWithResourcesAndTasksAsync = async (): Promise<
    ModuleWithResourcesAndTasksResponseApi[] | never
  > => {
    let url: string =
      serverOrigin + this.path + "/show/all?withResourcesAndTasks=true";

    let responseBody: ModuleWithResourcesAndTasksResponseApi[] =
      await getTypeGuardedArrayVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isModuleWithResourcesAndTasksResponseDTO
      );

    return responseBody;
  };

  async sendToGetAllModulesAsync(): Promise<ModuleResponseApi[] | never> {
    let url: string = serverOrigin + this.path + "/show/all";

    let responseBody: ModuleResponseApi[] =
      await getTypeGuardedArrayVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isModuleResponseDTO
      );

    return responseBody;
  }

  sendToDeleteModuleAsync = async (moduleId: string): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ moduleId: moduleId }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  };
}

let moduleServerClient = new ModuleServerClient();

export default moduleServerClient;
